import { Reveal } from "./Reveal";

const ALBUMS = [
  {
    type: "album",
    id: "4brJX3aUKnLsytuUddcChE",
    title: "SAFE!",
    cover: "https://image-cdn-ak.spotifycdn.com/image/ab67616d00001e02cd1f7a4f495634ce8db5d646",
    grad: "linear-gradient(135deg, #0b2a14 0%, #1f7a37 100%)",
    ring: "rgba(79,176,74,0.55)",
  },
  {
    type: "album",
    id: "0YwFC9K2Xqgz9DsLOuZuMn",
    title: "Resurrection",
    cover: "https://image-cdn-fa.spotifycdn.com/image/ab67616d00001e028044ca65f0b347711fcb047c",
    grad: "linear-gradient(135deg, #0b2a14 0%, #1f7a37 100%)",
    ring: "rgba(79,176,74,0.55)",
  },
  {
    type: "album",
    id: "5fWXzZWeKtJWdX3xQXt7JH",
    title: "belong2me",
    cover: "https://image-cdn-ak.spotifycdn.com/image/ab67616d00001e02448258463845b19fcd5a20a7",
    grad: "linear-gradient(135deg, #0f241d 0%, #2f8f5f 100%)",
    ring: "rgba(45,143,79,0.6)",
  },
  {
    type: "track",
    id: "4cLzPpk2OsBSGB6Gj1fJBX",
    title: "Can You Be Mine",
    cover: "https://image-cdn-fa.spotifycdn.com/image/ab67616d00001e02ce453231450c924d2904e936",
    grad: "linear-gradient(135deg, #0b2a14 0%, #256b3c 100%)",
    ring: "rgba(79,176,74,0.55)",
  },
];

export default function NowPlaying() {
  return (
    <section
      id="now-playing"
      className="relative bg-obsidian pt-28 md:pt-36 pb-16 md:pb-24 border-b border-white/10"
      data-testid="now-playing-section"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal className="mb-10 md:mb-14 flex items-end gap-4">
          <div>
            <p className="overline text-gold mb-5">Now Playing</p>
            <h2 className="headline text-5xl md:text-7xl text-white leading-none">Fresh From The <span className="text-gold">Lab</span></h2>
          </div>
          <span className="hidden sm:flex items-end gap-1 pb-2" aria-hidden>
            {[0, 1, 2, 3].map((i) => (
              <span
                key={i}
                className="w-1.5 bg-gold rounded-full nowplaying-bar"
                style={{ animationDelay: `${i * 0.15}s`, height: "22px" }}
              />
            ))}
          </span>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6">
          {ALBUMS.map((a, i) => (
            <Reveal key={a.id} delay={i * 0.08}>
              <div
                className="rounded-2xl overflow-hidden border"
                style={{ borderColor: a.ring, background: a.grad, boxShadow: `0 24px 64px -24px ${a.ring}` }}
              >
                <div className="flex items-center gap-5 p-5">
                  <img
                    src={a.cover}
                    alt={a.title}
                    className="w-20 h-20 md:w-24 md:h-24 rounded-lg object-cover shadow-[0_10px_24px_-8px_rgba(0,0,0,0.7)]"
                  />
                  <div className="min-w-0">
                    <p className="font-display uppercase tracking-[0.2em] text-[0.6rem] text-white/70 mb-1">Now Playing</p>
                    <h3 className="font-display text-2xl md:text-3xl text-white truncate">{a.title}</h3>
                    <a
                      href={`https://open.spotify.com/${a.type}/${a.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 mt-2 font-display uppercase tracking-[0.14em] text-[0.72rem] text-white/90 hover:text-white transition-colors"
                    >
                      Listen on Spotify →
                    </a>
                  </div>
                </div>
                <div className="bg-black/40 backdrop-blur-sm">
                  <iframe
                    title={`spotify-${a.type}-${i}`}
                    src={`https://open.spotify.com/embed/${a.type}/${a.id}?theme=0`}
                    width="100%"
                    height="152"
                    frameBorder="0"
                    loading="lazy"
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                    data-testid={`now-playing-album-${i}`}
                  />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes nowplayingBounce {
          0%, 100% { transform: scaleY(0.35); }
          50% { transform: scaleY(1); }
        }
        .nowplaying-bar { transform-origin: bottom; animation: nowplayingBounce 0.9s ease-in-out infinite; }
      `}</style>
    </section>
  );
}
